import { render } from "./EditCallQueueDetail.vue?vue&type=template&id=4e3d732b"
import script from "./EditCallQueueDetail.vue?vue&type=script&lang=js"
export * from "./EditCallQueueDetail.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__